export default {
    setInvoiceFilterFieldsMutation(state, payload)
    {
        state.invoiceFilter.fields.invoiceCompanyId = payload.invoice_company_id;
        state.invoiceFilter.main_filter = payload.main_filter;
    },
    setInvoiceList(state, payload)
    {
        state.invoiceList = payload;
    },
    setInvoiceListCount(state, payload) {
        state.invoiceListCount = payload;
    },
}
